// extracted by mini-css-extract-plugin
export default {"brandPromo":"uG-z","carousel":"vG-z"};